// extracted by mini-css-extract-plugin
export default {"tours-container":"Tours_tours-container__stEtn","our-tours":"Tours_our-tours__hyHPd","line":"Tours_line__BMHMf","button":"Tours_button__dUUXL"};